var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 42.666C19.8833 42.666 21.8333 40.716 21.8333 38.3327H13.1666C13.1666 40.716 15.1166 42.666 17.5 42.666ZM30.5 29.666V18.8327C30.5 12.181 26.9683 6.61268 20.75 5.13935V3.66602C20.75 1.86768 19.2983 0.416016 17.5 0.416016C15.7016 0.416016 14.25 1.86768 14.25 3.66602V5.13935C8.05329 6.61268 4.49996 12.1593 4.49996 18.8327V29.666L0.166626 33.9994V36.166H34.8333V33.9994L30.5 29.666ZM26.1666 31.8327H8.83329V18.8327C8.83329 13.4593 12.105 9.08268 17.5 9.08268C22.895 9.08268 26.1666 13.4593 26.1666 18.8327V31.8327Z",
    fill: "#BCCCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.265e88625811e62aa7f4e87dc77a8eca.svg";
export { ForwardRef as ReactComponent };